<template>
  <section
    class="add_new_head white--body tx--bege relative cover m_bg_blue no_mobile"
    style="background-image:url('/assets/img/layout/bg_serg.jpg');"
  >
    <div class="popup_close close-animate">
      <a @click="$emit('goBackRoute')"><CloseSvg /></a>
    </div>
    <a
      v-show="!editSurgery || (editSurgery && stage !== 2)"
      class="no_mobile link_goback"
      @click="$emit('onPrevStage')"
    >
      חזרה <ArrowBack />
    </a>
    <div class="inner_width flex flex--column center">
      <h1 class="title">
        <span class="bold"
          >{{ editSurgery ? "עריכת" : "יצירת" }} ניתוח לשיבוץ -</span
        >{{ activeDoctor.name }}
      </h1>
      <div class="add_step_all flex flex--content--center">
        <div class="add_step_all flex flex--content--center">
          <div class="add_step" :class="stage < 1 ? '' : 'active'">1</div>
          <div class="add_step" :class="stage < 2 ? '' : 'active'">2</div>
          <div class="add_step" :class="stage < 3 ? '' : 'active'">3</div>
          <div class="add_step" :class="stage < 4 ? '' : 'active'">4</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ArrowBack from "@/assets/img/svg/arrow_r.svg";
import CloseSvg from "@/assets/img/svg/close.svg";

export default {
  props: ["stage", "editSurgery", "activeDoctor"],
  components: { ArrowBack, CloseSvg }
};
</script>
